export default __webpack_public_path__ + "static/media/coloring_mouse_color.947b6eb7.jpg";